import React__default from 'react';

/** This hook allows quickly find option by it value */
function useOptionsMap(options) {
    const optionsMap = React__default.useMemo(() => {
        if (!options) {
            return {};
        }
        return options.reduce((acc, o) => {
            acc[o.value] = o;
            return acc;
        }, {});
    }, [options]);
    const getOptionByValue = React__default.useCallback((value) => optionsMap[value] || {}, [optionsMap]);
    return getOptionByValue;
}

export { useOptionsMap };
//# sourceMappingURL=useOptionsMap.js.map
